import { ITypedReduxAction } from '../../types/redux/actionType';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export enum EOpenedPhonesTypes {
  SetOpenedPhones = 'openedPhones/SetOpenedPhones',
}

interface ISetOpenedPhonesPayload {
  [key: string]: { realtyUserId: number; phone: string }[];
}

export type TSetOpenedPhonesData = ITypedReduxAction<EOpenedPhonesTypes.SetOpenedPhones, ISetOpenedPhonesPayload>;

export const setOpenedPhones = actionGenerator<EOpenedPhonesTypes.SetOpenedPhones, ISetOpenedPhonesPayload>(
  EOpenedPhonesTypes.SetOpenedPhones,
);

export type TSetOpenedPhonesActions = TSetOpenedPhonesData;
